import React from 'react';
import PropTypes from 'prop-types';

import {Box, Grid, Typography, TextField, Button} from 'views/components';
import {Translate, translate} from 'views/module';

import {navigate} from 'gatsby';

const SignupBottom = (props) => {
  const textfieldRef = React.useRef(null);

  const [email, setEmail] = React.useState(false);
  const [valid, setValid] = React.useState(false);

  const onSubmit = (e) => {
    e.preventDefault();

    if (!valid) {
      if (textfieldRef.current) {
        textfieldRef.current.focus();
      }
      return;
    }

    navigate(`/get-started/?email=${email}`);
  };

  return (
    <Box
      sx={{
        'maxWidth': '90vw',
        'width': {lg: '600px', xs: '100%'},
        'pt': 4,
      }}
    >
      <form onSubmit={onSubmit} >
        <Grid container spacing={{md: 1.5, xs: 0}}>
          <Grid item xs={12} >
            <TextField
              name='email'
              value={email}
              onChange={setEmail}
              label={translate('generic.Signup.Form.Email')}
              fullWidth
              validation={{
                regex: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                update: setValid,
              }}
              sx={{
                backgroundColor: '#fcfcff',
              }}
              inputProps={{style: {fontSize: '1rem'}}} // font size of input text
              InputLabelProps={{style: {fontSize: '1rem'}}} // font size of input label
              inputRef={textfieldRef}
            />
          </Grid>
          <Grid item xs={12}
            sx={{
              py: 1,
            }}
          >
            <Typography
              variant='caption'
            >
              <Translate expression='generic.Signup.Form.Agreement' />
            </Typography>
          </Grid>
          <Grid item xs={12} >
            <Button
              variant='contained'
              color='secondary'
              sx={{
                '&:disabled': {
                  backgroundColor: 'secondary.main',
                },
                'borderRadius': '100px',
              }}
              onClick={onSubmit}
            >
              <Typography
                sx={{
                  'color': 'color.white',
                  'fontWeight': 700,
                  'fontSize': '1rem',
                  'py': 1,
                  'px': 2,
                }}
              >
                <Translate expression='generic.Signup.Form.GetStarted' />
              </Typography>
            </Button>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};

SignupBottom.propTypes = {
  request: PropTypes.object.isRequired,
  setRequest: PropTypes.func.isRequired,
  nextStep: PropTypes.func.isRequired,
};

export default SignupBottom;
